import { createContext, useContext } from 'react';

const OfflineUploadQueueContext = createContext(null);

export function useOfflineUploadQueue() {
  const ctx = useContext(OfflineUploadQueueContext);

  if (!ctx) {
    throw new Error('useOfflineUploadQueue must be used within OfflineUploadQueueProvider');
  }

  return ctx;
}

export default OfflineUploadQueueContext;